
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DELIVERY_ZONE_REGION_NAME"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"intervals"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"has_morning_deliveries"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"has_evening_deliveries"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"days_of_week_for_morning_delivery"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"days_of_week_for_evening_delivery"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"morning_intervals"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time_from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"time_to"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"evening_intervals"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time_from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"time_to"},"arguments":[],"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DELIVERY_ZONE_ADDRESS_PRICE"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"address"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"addressValue"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}]},{"kind":"Field","name":{"kind":"Name","value":"beltway_distance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"street"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"house"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"longitude"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"delivery_price_low"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"delivery_price_other"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":585}};
    doc.loc.source = {"body":"fragment DELIVERY_ZONE_REGION_NAME on intervals {\n    region_name\n    id\n    has_morning_deliveries\n    has_evening_deliveries\n    days_of_week_for_morning_delivery\n    days_of_week_for_evening_delivery\n    morning_intervals {\n        time_from\n        time_to\n    }\n    evening_intervals {\n        time_from\n        time_to\n    }\n}\n\nfragment DELIVERY_ZONE_ADDRESS_PRICE on address {\n    id\n    type\n    addressValue @client\n    beltway_distance\n    street\n    house\n    city\n    coordinates {\n        latitude\n        longitude\n    }\n    delivery_price_low\n    delivery_price_other\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DELIVERY_ZONE_REGION_NAME"] = oneQuery(doc, "DELIVERY_ZONE_REGION_NAME");
        
        module.exports["DELIVERY_ZONE_ADDRESS_PRICE"] = oneQuery(doc, "DELIVERY_ZONE_ADDRESS_PRICE");
        
